import { PagePathService } from '@/src/services/PagePathService'
import Link from 'next/link'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { HStack } from '../../../parts/bases/HStack'
import { Text } from '../../../parts/bases/Text'
import { VStack } from '../../../parts/bases/VStack'

type TabType = 'Status' | 'Showcase' | 'Craft' | 'Activity' | 'Information' | 'Others'

export type Props = {
  activeTab: TabType
}

export const Layout = (props: Props) => {
  const { t } = useTranslation()
  return (
    <HStack className="items-start">
      <Tab isActive={props.activeTab === 'Status'} href={PagePathService.arcadeMachineManagerStatus()}>
        {t('ArcadeMachineManagerPage.TabStatus')}
      </Tab>
      <Tab isActive={props.activeTab === 'Showcase'} href={PagePathService.arcadeMachineManagerShowcase()}>
        {t('ArcadeMachineManagerPage.TabShowcase')}
      </Tab>
      <Tab isActive={props.activeTab === 'Craft'} href={PagePathService.arcadeMachineManagerCraft()}>
        {t('ArcadeMachineManagerPage.TabCraft')}
      </Tab>
      <Tab isActive={props.activeTab === 'Activity'} href={PagePathService.arcadeMachineManagerActivity()}>
        {t('ArcadeMachineManagerPage.TabActivity')}
      </Tab>
      <Tab
        isActive={props.activeTab === 'Information'}
        href={PagePathService.arcadeMachineManagerInformation()}
      >
        {t('ArcadeMachineManagerPage.TabInformation')}
      </Tab>
      <Tab isActive={props.activeTab === 'Others'} href={PagePathService.arcadeMachineManagerOthers()}>
        {t('ArcadeMachineManagerPage.TabOthers')}
      </Tab>
    </HStack>
  )
}

const Tab = (props: { href: string; children: ReactNode; isActive: boolean }) => {
  return (
    <Link href={props.href} className="mr-4">
      <a>
        <VStack className={`h-8 border-b-neon-blue px-5 ${props.isActive ? 'border-b' : 'border-b-0'}`}>
          <Text className={`text-base font-bold ${props.isActive ? 'text-neon-blue' : 'text-white'}`}>
            {props.children}
          </Text>
        </VStack>
      </a>
    </Link>
  )
}
